import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://mydigitalaction.it";
const DEFAULT_IMAGE = `${SITE}/og-image.png`;

/**
 * Per-page SEO head manager (title, description, canonical, robots, Open Graph,
 * Twitter and optional JSON-LD). Overrides the static defaults in index.html.
 */
export const Seo = ({
  title,
  description,
  path = "",
  canonical,
  noindex = false,
  image = DEFAULT_IMAGE,
  jsonLd,
}) => {
  const url = canonical || `${SITE}${path}`;
  const robots = noindex
    ? "noindex, follow"
    : "index, follow, max-image-preview:large";

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta name="robots" content={robots} />
      <meta name="googlebot" content={robots} />

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default Seo;
